import { render, staticRenderFns } from "./InventoryViewer.vue?vue&type=template&id=1e5e04a8&"
import script from "./InventoryViewer.vue?vue&type=script&lang=js&"
export * from "./InventoryViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports